import React from 'react';
import { FaStar } from 'react-icons/fa';

const RatingStar = () => {
  return <FaStar color="#9d20b1" />;
};

export default RatingStar;